import React, { Fragment } from 'react';
import { Route, NavLink, Redirect } from 'react-router-dom';
import { FooterLinks } from './footer-links';

class Footer extends React.Component {
    render () {
        
        return (
            <div className="mzd-footer">

                <div className="row expanded align-evenly">
                    <div className="fl-section">
                        <div className="logo-micro alt"></div>
                    </div>
                    {/* Muzado Col */}
                    <div className="footer-link-row" style={{listStyleType: 'none'}}>
                        <span className="fl-section">
                            <div><a className="muz-link" target="_blank" href={FooterLinks.ABOUT}>About</a></div>
                            <div><a className="muz-link" target="_blank" href={FooterLinks.PRESS}>Press</a></div>
                            <div>Terms and Conditions</div>
                            <div>Privacy Policy</div>
                            <div><a className="muz-link" target="_blank" href={FooterLinks.CONTACTUS}>Contact Us</a></div>
                        </span>
                        <span className="fl-section">
                            <span className="footer-copyright">© {new Date().getFullYear()} Muzado LLC</span>
                        </span>
                        <span className="fl-section">
                            <a className="muz-link icon" target="_blank" href={FooterLinks.FACEBOOK}><i className="margin-right-1 fab fa-facebook-f"></i></a>
                            <a className="muz-link icon" target="_blank" href={FooterLinks.TWITTER}><i className="margin-right-1 fab fa-twitter"></i></a>
                            <a className="muz-link icon" target="_blank" href={FooterLinks.INSTAGRAM}><i className="margin-right-1 fab fa-instagram"></i></a>
                            <a className="muz-link icon" target="_blank" href={FooterLinks.YOUTUBE}><i className="margin-right-1 fab fa-youtube"></i></a>
                        </span>
                    </div>
                    {/*Plugs*/}
                    {/* <div className="column medium-3" style={{display: 'flex', alignItems: 'center'}}>
                        <div className="row" style={{color: '#7f7f7f', fontSize: '2.4rem'}}>
                            <a className="muz-link icon" target="_blank" href={FooterLinks.FACEBOOK}><i className="margin-right-1 fab fa-facebook-f"></i></a>
                            <a className="muz-link icon" target="_blank" href={FooterLinks.TWITTER}><i className="margin-right-1 fab fa-twitter"></i></a>
                            <a className="muz-link icon" target="_blank" href={FooterLinks.INSTAGRAM}><i className="margin-right-1 fab fa-instagram"></i></a>
                            <a className="muz-link icon" target="_blank" href={FooterLinks.YOUTUBE}><i className="margin-right-1 fab fa-youtube"></i></a>
                        </div>
                    </div> */}
                </div>
                {/* <div className="row expanded align-right" style={{width: '79vw'}}>
                <span className="footer-copyright">© {new Date().getFullYear()} Muzado LLC</span>
                </div> */}
            </div>
        )
    }
}
export default Footer;